import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import ExplainabilityWidgetItem from '../explainability-widget-item.component';
import STRING_KEYS from '../../../../../../../../language/keys';
import { ExplainabilityWidgetEducationProps } from './explainability-widget-education';
import { Icon } from './explainability-widget-education.styled';

const ExplainabilityWidgetEducation = ({ match }: ExplainabilityWidgetEducationProps): JSX.Element | null => {
  const { t: translate } = useTranslation();

  const mappedEducationList = useMemo<JSX.Element>(() => {
    const educations = match.talent.educationHistory?.reduce<JSX.Element[]>((acc, history) => {
      if (history.isPreferredInstitution || history.isPreferredEducation) {
        const hasOnlyInstitutionName = !history.degree && !history.fieldOfStudy;

        const element = hasOnlyInstitutionName ? (
          <span key={ `${history.institutionName}` }>{history.institutionName}</span>
        ) : (
          <span key={ `${history.institutionName}_${history.fieldOfStudy}` }>
            {
              `${[(history.degree), (history.fieldOfStudy)].filter(Boolean).join(', ')} ${translate(STRING_KEYS.AT)} ${history.institutionName}`
            }
          </span>
        );

        acc.push((
          <div>{ element }</div>
        ));
      }

      return acc;
    }, []);

    if (!educations?.length) {
      return null;
    }

    return <>{educations}</>;
  }, [match.talent.educationHistory, translate]);

  if (!mappedEducationList) {
    return null;
  }

  return (
    <ExplainabilityWidgetItem
      key="ExplainabilityWidgetEducation"
      label={ translate(STRING_KEYS.MATCH_CARD.EXPLAINABILITY_WIDGET.ITEMS_LABELS.EDUCATION) }
      value={ mappedEducationList }
      Icon={ Icon }
    />
  );
};

export default ExplainabilityWidgetEducation;
